import { useCallback } from 'react';
import { useSendModuleMessage } from '../../../LayoutConfiguration/ModuleMessaging';
import { ModuleType } from '../../Modules/basicModuleTypesConfig';

export type UseUpdateTimelineOnFavorite = {
  onFavoriteUpdate: () => void;
};

export const useUpdateTimelineOnFavorite = (): UseUpdateTimelineOnFavorite => {
  const sendModuleMessage = useSendModuleMessage();
  const onFavoriteUpdate = useCallback(() => {
    sendModuleMessage({
      targetModuleType: ModuleType.Timeline,
      type: 'favorites-update',
    });
  }, [sendModuleMessage]);

  return {
    onFavoriteUpdate,
  };
};
